import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import AppContent from './AppContent';
import GlobalLoader from './components/common/GlobalLoader';
import './api/setupAxiosGlobalLoader';
import { ThemeModeProvider } from './theme/ThemeModeContext';

const container = document.getElementById('root');
const root = createRoot(container);

const resizeObserverErr = /ResizeObserver loop completed with undelivered notifications/;
window.addEventListener('error', (event) => {
  if (resizeObserverErr.test(event.message)) {
    event.stopImmediatePropagation();
  }
});

root.render(
  <React.StrictMode>
    <ThemeModeProvider>
      <Suspense fallback={<GlobalLoader fullscreen visible label="Loading workspace" />}>
        <AppContent />
      </Suspense>
    </ThemeModeProvider>
  </React.StrictMode>
);
